import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { Button } from '@xingternal/button';
import { trackPageview } from '@xingternal/hops-tracking';
import { Column } from '@xingternal/xing-grid';

import { routes } from '@/config';

import * as S from './submit-error.styles';

export const SubmitError: React.VFC = () => {
  const history = useHistory();
  const { params } = useRouteMatch<{ slug: string }>();

  const onClose = (): void => history.replace(`${routes.jobs}/${params.slug}?sc_o=jobs_apply_error_exit`);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageview('wbm/Stellenmarkt/apply/error');
  }, []);

  return (
    <Column size={10} sizeWide={8} sizeConfined={10} offsetWide={2} offset={1}>
      <S.ContentWrapper>
        <S.ErrorImg width={160} />

        <S.Title size="small">
          <FormattedMessage id="JOBS_POSTING_APPLY_FORM_LO_ERROR_HEADLINE" />
        </S.Title>
        <S.Body size="medium">
          <FormattedMessage id="JOBS_POSTING_APPLY_FORM_LO_ERROR_BODY" />
        </S.Body>

        <Button onClick={onClose} size="medium" variant="secondary">
          <FormattedMessage id="JOBS_POSTING_EASY_APPLY_FORM_ERROR_CTA" />
        </Button>
      </S.ContentWrapper>
    </Column>
  );
};
